import Vue from "vue";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import validateDominicanId from "validacion-cedula-dominicana";

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

extend("required", {
  ...required,
  message: "Favor completar los campos obligatorios.",
});

extend("requiredConsulta", {
  ...required,
  message: "Favor completar los campos obligatorios para realizar la consulta.",
});

extend("cedula", {
  validate: (value) => {
    var removedText = value.replace(/\D/g,''); 
    return validateDominicanId(removedText);
  },
  message:
    "El número de cédula introducido no es válido. Por favor ingresa el número de cédula nuevamente.",
  computesRequired: true,
});

extend("telefono", {
  validate: (value) => {
    // Expresión regular que acepta números de teléfono internacionales con y sin espacios o guiones
    const phoneREG = /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneREG.test(value);
  },
  message: "Número de teléfono inválido.",
});

extend("emailAFP", {
  validate: (value) => {
    if (value) {
      //https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
      const EMAILREG = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      return EMAILREG.test(value);
    } else {
      return true;
    }
  },
  message: "Email inválido.",
});

extend("lowercase", {
  validate: (value) => {
    if (value) {
      return !!value
        .replace(/[^a-zA-Z]/gm, "")
        .split("")
        .find((x) => x === x.toLowerCase());
    }
  },
  message: "La clave debe contener al menos una (1) letra minúscula.",
});

extend("uppercase", {
  validate: (value) => {
    if (value) {
      return !!value
        .replace(/[^a-zA-Z]/gm, "")
        .split("")
        .find((x) => x === x.toUpperCase());
    }
  },
  message: "La clave debe contener al menos una (1) letra mayúscula.",
});

extend("containsNumber", (value) => {
  if (/\d/.test(value)) {
    return true;
  }
  return "La clave debe contener al menos un (1) número.";
});

extend("specialCharacter", (value) => {
  const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  if (format.test(value)) {
    return true;
  }
  return "La clave debe contener al menos un (1) caracter especial (_ @ * - ^ . :) .";
});

extend("mymax-validation", {
  validate: (value, params) => {
    var result = value && value.length <= params.length;
    return result;
  },
  message: "Este campo solo admite {length} o menos caracteres.",
  params: ["length"],
});

extend("mymin-validation", {
  validate: (value, params) => {
    var result = value && value.length >= params.length;
    return result;
  },
  message: "Este campo solo admite {length} o más caracteres.",
  params: ["length"],
});
extend("minimo-validation", {
  validate: (value, params) => { 
    var result = value.length >= Number(params["minimo"]);

    return result;
  },
  message: "Este campo admite un valor mínimo de  {minimo} carácteres.",
  params: ["minimo"],
});
extend("maximo-validation", {
  validate: (value, params) => { 
    var result = value.length <= Number(params["maximo"]);

    return result;
  },
  message: "Este campo admite un valor máximo de  {maximo} carácteres. ",
  params: ["maximo"],
});

extend("minimo-number-validation", {
  validate: (value, params) => { 
   try {
    var result = Number(value) >= Number(params["minimo"]);

    return result;
   }catch(x){
      return false
   }
  },
  message: "Este campo admite un valor mínimo de  {minimo} .",
  params: ["minimo"],
});
extend("maximo-number-validation", {
  validate: (value, params) => { 
    try {
      var result = Number(value) <= Number(params["maximo"]);

       return result;
      
    } catch (error) {
      return false;
    }
  },
  message: "Este campo admite un valor máximo de  {maximo} . ",
  params: ["maximo"],
});

extend("date", {
  validate: (value) => {
    if (value) {
      var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
      if (value.match(reg)) {
        return true;
      }
    }
    return false;
  },
  message: 'Esta fecha no es válida. Por favor utilizar "día/mes/año"',
});

extend("dateBeforeNow", {
  validate: (value:string) => {
    if (value) {
      var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
      if (value.match(reg)) {
        try{
           
          var date = value.split("/").reverse().join("/");
          console.log(value)
          let newDate =  Date.parse(date)
          let currentDate = Date.now(); 
          console.log(currentDate)
          console.log(newDate)
          if(newDate >=currentDate){
            return false;
          }
          
          var date1= new Date(currentDate)
          var date2= new Date(newDate)
          
          if(date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()){
            return false;
          }

          return true;
        }catch(error){ 
        } 
      }
    } 
  },
  message: 'Por favor introducir una fecha anterior al día de hoy.',
});
extend("februaryInvalidDay", {
  validate: (value:string) => {
    if (value) {
      var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
      if (value.match(reg)) {
        try{
          let fecha = value.split("/")
          console.log(fecha)
          var date = value.split("/").reverse().join("/");
          let newDate =  Date.parse(date)
          let currentDate = Date.now(); 
          let bisiesto = false;
          let year = Number(fecha[2]) 

          if ((0 == year % 4) && (0 != year % 100) || (0 == year % 400)) {
             if(Number(fecha[1]) ==2  && Number(fecha[0]) > 29){
            return false;
          }
          } else {
            if(Number(fecha[1]) ==2  && Number(fecha[0]) > 28){
              return false;
            }
          }

          
          return true;
        }catch(error){ 
        } 
      }
    } 
  },
  message: 'Esta fecha no es válida. Por favor utilizar "día/mes/año"',
});
extend("onlyNumbers", {
  validate: (value) => {

    if(/^\d+$/.test(value.trim())){
      let valor = parseInt(value);
      if(valor <=0){
        return false;
      }else{return true}
    }
    return /^\d+$/.test(value.trim());
  },
  message: 'Este campo solo admite números mayores a cero.',
});

extend("true", {
  validate: (value,params) => { 
    return value;
  },
  message: 'Favor completar los campos obligatorios.',
});
extend("noSpecialCharacters", {
  validate: (value) => { 
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    let hasSpechalChar = specialChars.test(value)
    return !hasSpechalChar;
  },
  message: 'Este campo no permite carácteres o símbolos especiales tales como !,@,#,$,%,etc.',
});

extend("differentValue", {
  validate: (value,params) => {  
    return value!= params["currentValue"];
  },
  message: 'El nuevo valor debe ser diferente a {currentValue} ',
  params: ["currentValue"],
});
extend("passwordSameValue", {
  validate: (value,params) => {  
    return value== params["currentValue"];
  },
  message: 'Ambas claves deben coincidir',
  params: ["currentValue"],
});

extend("alphabeticOnly", {
  validate: (value) => {
    // ^1?(809|829|849)-?[1-9]{1}?\d{2}-?\d{4}$
    // const phoneREG = /^1?(809|829|849)-?\d{3}-?\d{4}$/;
    const alphabeticOnly = /^[a-zA-Z\s\u00C0-\u017F]+$/;
    return alphabeticOnly.test(value);
  },
  message: "Este campo solo acepta letras.",
});
extend("telefonoFormated", {
  validate: (value) => {
    // Elimina caracteres de máscara adicionales y verifica el formato
    value = value.replace(/_/g, "").replace(/-/g, "").replace(/[{()}]/g, "").replace(/\s+/g, "");
    const phoneREG = /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneREG.test(value);
  },
  message: "Número de teléfono inválido.",
});
extend("sameValueTo", {
  validate: (value,params) => {  

    return true;
  },
  message: 'El nuevo valor debe ser igual a {currentValue} ',
  params: ["currentValue"],
});